import React from 'react';
import { followRequired, followRequirement } from '../lib/giveaway-policy';

export const GiveawayFollowRequirement = ({ brand }) => followRequired(brand) ? (
  <p className="giveaway-follow-requirement" data-testid="giveaway-follow-requirement">{followRequirement(brand)}</p>
) : null;